export default "dist/450feb46ce351888796576258185b205.otf";